module.exports = __webpack_public_path__ + "static/media/professional-beauty-banner.086437ee.png";